import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL } from "../lib/brand";

export const LegalLayout = ({ title, lastUpdated, children }) => {
  return (
    <div className="min-h-screen bg-[var(--al-bg)]">
      <header className="border-b border-[var(--al-line)] bg-white/80 backdrop-blur-xl">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <img src={LOGO_URL} alt="Alphalane" className="h-9 w-9 object-contain" />
            <span className="font-display font-semibold text-[15px]">
              <span className="al-grad-text">ALPHALANE</span>
              <span className="text-slate-500 text-xs ml-2 font-medium uppercase tracking-widest">Trading Systems</span>
            </span>
          </Link>
          <Link to="/" data-testid="legal-back-link" className="al-cta-ghost !py-2 !px-4 text-sm">
            <ArrowLeft className="h-4 w-4" /> Zurück
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <span className="al-tag">Rechtliches</span>
        <h1 className="mt-5 font-display font-bold text-4xl sm:text-5xl leading-tight">
          <span className="al-grad-text">{title}</span>
        </h1>
        {lastUpdated && (
          <p className="mt-3 text-sm text-slate-500">Stand: {lastUpdated}</p>
        )}
        <div className="al-divider mt-8" />
        <article className="legal-article mt-10">{children}</article>
      </main>

      <footer className="border-t border-[var(--al-line)] bg-white">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 py-6 flex flex-wrap items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Alphalane Trading Systems</div>
          <div className="flex gap-5">
            <Link to="/impressum" className="hover:text-slate-900">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-slate-900">Datenschutz</Link>
            <Link to="/agb" className="hover:text-slate-900">AGB</Link>
          </div>
        </div>
      </footer>

      <style>{`
        .legal-article h2 {
          font-family: 'Outfit', sans-serif;
          font-weight: 600;
          font-size: 1.5rem;
          margin-top: 2.5rem;
          margin-bottom: 0.75rem;
          color: var(--al-ink);
          letter-spacing: -0.02em;
        }
        .legal-article h3 {
          font-family: 'Outfit', sans-serif;
          font-weight: 600;
          font-size: 1.125rem;
          margin-top: 1.75rem;
          margin-bottom: 0.5rem;
          color: var(--al-ink);
        }
        .legal-article p {
          color: var(--al-ink-soft);
          line-height: 1.75;
          margin-bottom: 1rem;
        }
        .legal-article ul {
          color: var(--al-ink-soft);
          line-height: 1.75;
          margin: 0.75rem 0 1.25rem 1.25rem;
          list-style: disc;
        }
        .legal-article a { color: var(--al-purple); text-decoration: underline; }
        .legal-article strong { color: var(--al-ink); }
      `}</style>
    </div>
  );
};
